import { Box } from '@mui/material';
import { Field, FastField } from 'formik';

import { QuestionProps, buildFormKey } from '.';
import { CerebroLabel, CerebroRadioGroup, CerebroRadioButton, CerebroInput } from '../../shared/components';

export const DealQuestionYesNo: React.FC<QuestionProps> = ({ question, values, isSubmitting }) => {
	const valueKey = buildFormKey(question, 'value');
	const textKey = buildFormKey(question, 'text');

	const value = values[valueKey];
	const hasAnswered = value === 'Yes' || value === 'No';

	return (
		<>
			<CerebroLabel htmlFor={valueKey}>{question.questionText}</CerebroLabel>
			<FastField
				size="small"
				id={valueKey}
				sx={{ marginLeft: 1, marginTop: 2 }}
				as={CerebroRadioGroup}
				name={valueKey}
			>
				<CerebroRadioButton size="small" value="Yes" disabled={isSubmitting}>
					Yes
				</CerebroRadioButton>

				<CerebroRadioButton size="small" value="No" disabled={isSubmitting}>
					No
				</CerebroRadioButton>
			</FastField>

			{question.questionFormat == 'YesNoWithComment' && hasAnswered && (
				<Box sx={{ marginLeft: 2, marginTop: 2 }}>
					<CerebroLabel size="small" htmlFor={textKey}>
						Explain:{' '}
					</CerebroLabel>
					<FastField small id={textKey} name={textKey} as={CerebroInput} disabled={isSubmitting} />
				</Box>
			)}
		</>
	);
};
